import type { FC, ReactNode } from "react";

import { formatPhoneLocal, NO_VALUE_DISPLAY } from "@ryde/shared";

import { MapTooltipEllipsisValue } from "./map-tooltip-ellipsis-value";

const hasTooltipDetailText = (value: string | undefined | null): boolean =>
  Boolean(value?.trim());

interface IMapTooltipDetailRowProps {
  label: string;
  text?: string | null;
  children?: ReactNode;
}

/** Detail row hidden when value is empty (no `--` placeholder). */
export const MapTooltipDetailRow: FC<IMapTooltipDetailRowProps> = ({
  label,
  text,
  children,
}) => {
  if (children) {
    return (
      <div className="detail-row">
        <span className="detail-row__label">{label}</span>
        {children}
      </div>
    );
  }

  if (!hasTooltipDetailText(text)) {
    return null;
  }

  return (
    <div className="detail-row">
      <span className="detail-row__label">{label}</span>
      <MapTooltipEllipsisValue text={text?.trim() ?? ""} />
    </div>
  );
};

interface IMapTooltipDriverRowProps {
  label: string;
  name?: string | null;
  phone?: string | null;
}

export const MapTooltipDriverRow: FC<IMapTooltipDriverRowProps> = ({
  label,
  name,
  phone,
}) => {
  const trimmedName = name?.trim();
  const trimmedPhone = phone?.trim();

  if (!trimmedName && !trimmedPhone) {
    return null;
  }

  return (
    <div className="detail-row">
      <span className="detail-row__label">{label}</span>
      <span className="detail-row__value">
        {trimmedName || NO_VALUE_DISPLAY}
        {trimmedPhone ? (
          <>
            {trimmedName ? " · " : null}
            <a href={`tel:${trimmedPhone}`}>{formatPhoneLocal(trimmedPhone)}</a>
          </>
        ) : null}
      </span>
    </div>
  );
};
